import { initializeApp, getApps, getApp, FirebaseOptions } from "firebase/app";
import { env } from "@/app/env";

export const config: FirebaseOptions =
  env.NEXT_PUBLIC_ENVIRONMENT === "prod"
    ? {
        apiKey: "AIzaSyBUbXRwy0L8AVVPlc6ro0UYyRFLCFUFG70",
        appId: "1:747003873536:web:7938be052d6ef0dbd2cbe5",
        // This has to be the same as the domain the site is served from. That way the
        // user's tokens will be stored under that origin and our code will be allowed
        // to read them.
        authDomain: "cat.app.anu.edu.au",
        databaseURL: "",
        measurementId: "",
        messagingSenderId: "747003873536",
        projectId: "anu-cat-app-prod",
        storageBucket: "anu-cat-app-prod.firebasestorage.app",
      }
    : {
        apiKey: "AIzaSyC8v_nwnlZMM6kG8cp4Of90Cc257uw1I6Q",
        appId: "1:960850028206:web:cc96574a96f34e31042f3f",
        // This has to be the same as the domain the site is served from. That way the
        // user's tokens will be stored under that origin and our code will be allowed
        // to read them.
        authDomain: "cat.app-test.anu.edu.au",
        databaseURL: "",
        measurementId: "",
        messagingSenderId: "960850028206",
        projectId: "anu-cat-app-test",
        storageBucket: "anu-cat-app-test.firebasestorage.app",
      };

export const app = getApps().length === 0 ? initializeApp(config) : getApp();
